"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const lodash_1 = __importDefault(require("lodash"));
const sizeof_1 = require("sizeof");
class Logger {
    constructor(url, info) {
        this.logs = [];
        this.loggerUrl = url;
        this.labels = info;
        this.start();
    }
    static ObjectSize(object) {
        try {
            return (0, sizeof_1.sizeof)(object);
        }
        catch (error) {
            return Logger.LOG_MAX_SIZE;
        }
    }
    start() {
        if (this.flushIntervalId != null) {
            this.stop();
        }
        this.flushIntervalId = setInterval(() => {
            this.flush();
        }, Logger.FLUSH_INTERVAL);
    }
    stop() {
        clearInterval(this.flushIntervalId);
    }
    setMerchantId(merchantId) {
        this.labels.merchantId = merchantId;
    }
    setDeviceId(deviceId) {
        this.labels.deviceId = deviceId;
    }
    setUserId(userId) {
        this.labels.userId = userId;
    }
    setEnv(environment) {
        this.labels.environment = environment;
    }
    log(level, data, timestamp) {
        const newLog = {
            level,
            data,
            timestamp,
        };
        const stashLogSize = Logger.ObjectSize(this.logs); // 現存的 logs 大小
        let newLogSize = Logger.ObjectSize(newLog); // 新的 log 大小
        if (newLogSize > Logger.LOG_MAX_SIZE) {
            // 單一 log 大小已超過限制，將 newLog 改成只送出 message 並留下警告
            newLog.level = 'warn';
            newLog.data = { message: newLog.data.message, warning: `log size over limit ${Logger.LOG_MAX_SIZE} bytes, send message without other data`, size: newLogSize };
            newLogSize = Logger.ObjectSize(newLog); // 更新 size
        }
        // 加入 log
        this.logs.push(newLog);
        if (['error', 'warn'].includes(level) || // 遇到 error 或 warn  level 的 log 就優先送出
            this.logs.length >= Logger.LOG_MAX_LENGTH || // 加入新的 log 後長度達到限制，立即送出
            stashLogSize + newLogSize >= Logger.LOG_MAX_SIZE // 加入新 log 後大小達到上限，立即送出
        ) {
            this.flush();
        }
    }
    flush() {
        if (this.logs.length === 0)
            return;
        const logs = lodash_1.default.clone(this.logs);
        this.logs = [];
        const logSize = Logger.ObjectSize(logs);
        if (logSize >= Logger.LOG_MAX_SIZE) {
            // 超過大小時，最後一筆放入 logs 下一次再送
            const lastLog = logs.pop();
            this.logs.push(lastLog);
        }
        axios_1.default
            .post(this.loggerUrl, {
            logs,
            labels: lodash_1.default.chain(this.labels).omitBy(lodash_1.default.isNull).omitBy(lodash_1.default.isUndefined).value(),
        })
            .catch((error) => {
            const data = lodash_1.default.get(error, 'config.data', {});
            const dataSize = Logger.ObjectSize(data);
            const message = `${logs.length} logs sended failed, size: ${dataSize}, error: ${String(error)}`;
            console.log(message, error);
            this.log('error', Object.assign(Object.assign({}, error), { message }), new Date().toISOString());
        });
    }
    asyncFlush() {
        if (this.logs.length === 0)
            return;
        const logs = lodash_1.default.clone(this.logs);
        this.logs = [];
        const logSize = Logger.ObjectSize(logs);
        if (logSize >= Logger.LOG_MAX_SIZE) {
            // 超過大小時，最後一筆放入 logs 下一次再送
            const lastLog = logs.pop();
            this.logs.push(lastLog);
        }
        return axios_1.default.post(this.loggerUrl, {
            logs,
            labels: lodash_1.default.chain(this.labels).omitBy(lodash_1.default.isNull).omitBy(lodash_1.default.isUndefined).value(),
        });
    }
}
exports.default = Logger;
Logger.LOG_MAX_LENGTH = 500;
Logger.LOG_MAX_SIZE = 256000;
Logger.FLUSH_INTERVAL = 5000;
//# sourceMappingURL=Logger.js.map